"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _jsxFileName = "/home/cej/Documents/VS_Code/MWeeB/nq-component/src/Signature/index.js";
var defaultProps = {};
function SignatureCanvas(_ref) {
  var setRef = _ref.setRef;
  _react["default"].useEffect(function () {
    var canvas = setRef.current;
    var ctx = canvas.getContext("2d");
    var isDrawing = false;
    var lastX = 0;
    var lastY = 0;
    function draw(x, y) {
      if (!isDrawing) return;
      // Set line dash to a solid line
      // ctx.setLineDash([]);
      // Draw a quadratic Bezier curve
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      var cpX = (lastX + x) / 2; // Control point X
      var cpY = (lastY + y) / 2; // Control point Y
      // ctx.quadraticCurveTo(lastX, lastY, cpX, cpY);
      ctx.lineTo(x, y);
      ctx.stroke();
      lastX = x;
      lastY = y;
    }
    function handlePointerDown(e) {
      isDrawing = true;
      var clientX = e.clientX,
        clientY = e.clientY;
      var _canvas$getBoundingCl = canvas.getBoundingClientRect(),
        left = _canvas$getBoundingCl.left,
        top = _canvas$getBoundingCl.top;
      lastX = clientX - left;
      lastY = clientY - top;
    }
    function handlePointerMove(e) {
      e.preventDefault();
      draw(e.clientX - canvas.getBoundingClientRect().left, e.clientY - canvas.getBoundingClientRect().top);
    }
    function handlePointerUp(e) {
      isDrawing = false;
    }
    canvas.addEventListener("pointerdown", handlePointerDown);
    canvas.addEventListener("pointermove", handlePointerMove);
    canvas.addEventListener("pointerup", handlePointerUp);
  }, []);
  function handleClear() {
    var canvas = setRef.current;
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  function handleResize() {
    var canvas = setRef.current;
    var container = canvas.parentNode;
    canvas.width = container.offsetWidth;
    canvas.height = container.offsetHeight;
  }
  function handleSave() {
    var canvas = setRef.current;
    var link = document.createElement("a");
    link.download = "signature.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  }
  _react["default"].useEffect(function () {
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  var defaultStyle = {
    touchAction: "none",
    userSelect: "none",
    position: "relative",
    width: "100%",
    height: "0",
    paddingTop: "50%"
  };
  function handleClear() {
    var canvas = setRef.current;
    var ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-light",
    style: defaultStyle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 9
    }
  }, /*#__PURE__*/_react["default"].createElement("canvas", {
    ref: setRef,
    style: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%"
    },
    onContextMenu: function onContextMenu(e) {
      return e.preventDefault();
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 13
    }
  }), /*#__PURE__*/_react["default"].createElement("button", {
    onClick: handleClear,
    style: {
      position: 'absolute',
      top: 5,
      right: 5,
      border: 'none',
      background: 'none'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 13
    }
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "bi bi-eraser",
    style: {
      fontSize: '2rem',
      color: 'red'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 17
    }
  })));
}
SignatureCanvas.defaultProps = defaultProps;
var _default = exports["default"] = SignatureCanvas;